import { requestApi } from '../util/network'
// 获取积分兑换商品详情
export const getPointshop =
    () =>
      requestApi(
        '/Pointshop/index',
        'POST',
        {}
      )
// 获取积分兑换店铺代金券列表
export const getPointVoucherList =
    (params) =>
      requestApi(
        '/Pointvoucher/index',
        'POST',
        {
          'page': params.page,
          'per_page': params.per_page,
          'client_type': 'wap'
        }
      )
// 积分兑换店铺代金券
export const exchangePointVoucher =
    (params) =>
      requestApi(
        '/Pointvoucher/voucherexchange_save',
        'POST',
        params
      )
// 获取积分兑换代金券列表
export const getPointMallVoucherList =
    (params) =>
      requestApi(
        '/Pointmallvoucher/index',
        'POST',
        {
          'page': params.page,
          'per_page': params.per_page,
          'gc_id':params.gc_id,
          'client_type': 'wap'
        }
      )
// 积分兑换平台代金券
export const exchangePointMallVoucher =
    (params) =>
      requestApi(
        '/Pointmallvoucher/mallvoucherexchange_save',
        'POST',
        params
      )
// 获取积分兑换商品列表
export const getPointsgoodsList =
    (params) =>
      requestApi(
        '/Pointprod/index',
        'POST',
        {
          'page': params.page,
          'per_page': params.per_page,
          'client_type': 'wap'
        }
      )
// 获取积分兑换商品详情
export const getPointsgoodsInfo =
    (id) =>
      requestApi(
        '/Pointprod/pinfo',
        'POST',
        {
          'id': id
        }
      )
// 获取积分兑换商品订单列表
export const getPointsorderList =
    (params, id) =>
      requestApi(
        '/Pointprod/get_order_list',
        'POST',
        {
          'page': params.page,
          'per_page': params.per_page,
          'pgoods_id': id
        }
      )
